/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_P_Event_DescInputs */

const en_cp_p_event_desc = /** @type {(inputs: Cp_P_Event_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sponsorship for student societies, GDG on Campus, internal competition selections: free team accounts for 45 days for up to 100 teams, a build-night kit, one judge/mentor session, credits for winners.`)
};

const id_cp_p_event_desc = /** @type {(inputs: Cp_P_Event_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sponsor untuk himpunan, GDG on Campus, seleksi internal Gemastik/KMIPN: akun tim gratis 45 hari untuk s/d 100 tim, kit build night, juri/mentor 1 sesi, kredit untuk pemenang.`)
};

/**
* | output |
* | --- |
* | "Sponsorship for student societies, GDG on Campus, internal competition selections: free team accounts for 45 days for up to 100 teams, a build-night kit, one..." |
*
* @param {Cp_P_Event_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_p_event_desc = /** @type {((inputs?: Cp_P_Event_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_P_Event_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_p_event_desc(inputs)
	return en_cp_p_event_desc(inputs)
});